import Vue from "vue";

const state = {
  authenticatedUser: {
    // 顧客名
    customerName: "",
    // ログインユーザ名
    loginUserName: "",
    // 前回ログイン日時
    lastloginDate: "",
    // セッションタイムアウト
    sessionTimeOut: "",
    // システムデータ有無確認フラグ
    settingSystemFlg: false,
    // 請求先フラグ
    invoiceExistFlg: false
  }
};

const getters = {
  authenticatedUser: state => state.authenticatedUser,
  settingSystemFlg: state => state.settingSystemFlg
};

const actions = {
  // ユーザ情報を取得
  async getAuthenticatedUser({ commit }) {
    await Vue.axios.get("/get-authenticated-user").then(response => {
      const data = response.data;
      if (data) {
        commit("getAuthenticatedUser", data);
      }
    });
  }
};

const mutations = {
  getAuthenticatedUser(state, payload) {
    bindDataUser(state, payload);
  },
  updateSystemInfo(state, settingSystemFlg) {
    state.authenticatedUser.settingSystemFlg = settingSystemFlg;
  }
};

function bindDataUser(state, payload) {
  state.authenticatedUser.customerName = payload.customer_name;
  state.authenticatedUser.loginUserName = payload.login_username;
  state.authenticatedUser.lastloginDate = payload.lastlogin_date;
  state.authenticatedUser.sessionTimeOut = payload.session_time_out;
  state.authenticatedUser.settingSystemFlg = payload.setting_system_flg;
  state.authenticatedUser.invoiceExistFlg = payload.invoice_exist_flg;
}

export default {
  state,
  getters,
  actions,
  mutations
};
